import OrdersToReviewModule from './OrdersToReview.module';

export default OrdersToReviewModule;
